import Vue from "vue";
import Vuelidate from "vuelidate";
import App from "@/App.vue";
import vSelect from "vue-select";
import router from "@/router";
import store from "@/store";
import "@/components/global-components";
import "@/mixins/mixins";
import VueCookies from "vue-cookies";
import * as Sentry from "@sentry/vue";

Vue.use(Vuelidate);
Vue.use(VueCookies, { expires: "90d" });
Vue.config.productionTip = false;

Vue.component("v-select", vSelect);

if (process.env.VUE_APP_SENTRY_ENABLED === "true") {
  const environment = process.env.VUE_APP_SENTRY_ENVIRONMENT || "staging";
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: environment,
    integrations: [
      Sentry.replayIntegration({
        unmask: ["label", "h1", "p", "button", "h2"],
      }),
    ],

    attachProps: true,
    attachStacktrace: true,
    replaysOnErrorSampleRate: 1.0,
  });
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
